module.exports = __webpack_public_path__ + "static/img/lucilas-1.160e1ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/lucilas-1.jpg
// module id = Cd/F
// module chunks = 1